import React, { useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import type { ComponentData, NodeViewRendererProps } from 'ricos-types';

import { HTML_TYPE } from '../types';
import { HtmlViewer } from './html-viewer';

const Html = ({ node, nodeIndex, NodeViewContainer }: NodeViewRendererProps) => {
  const { iframeSandboxDomain, config } = useContext(RicosViewerContext);
  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <HtmlViewer
        componentData={node.htmlData as ComponentData}
        settings={config[HTML_TYPE]}
        iframeSandboxDomain={iframeSandboxDomain}
        isViewer
      />
    </NodeViewContainer>
  );
};

export default Html;
